import { useEffect, useState } from "react";

const links = [
  { label: "Perfil", href: "#perfil" },
  { label: "Estadísticas", href: "#estadisticas" },
  { label: "Trayectoria", href: "#trayectoria" },
  { label: "Galería", href: "#galeria" },
  { label: "Videos", href: "#videos" },
  { label: "Contacto", href: "#contacto" },
];

export function LogoMark({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" data-testid="logo-mark" aria-label="Cristian Díaz">
      <rect width="64" height="64" rx="10" fill="#0f0f0f" stroke="#262626" />
      <path d="M32 6l2.6 5.3 5.9.9-4.3 4.1 1 5.8L32 19.3l-5.2 2.8 1-5.8-4.3-4.1 5.9-.9z" fill="#d4af37" />
      <text x="32" y="50" textAnchor="middle" fontFamily="'Barlow Condensed',sans-serif" fontWeight="900" fontSize="26" fill="#fafafa">CD</text>
    </svg>
  );
}

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (e, href) => {
    e.preventDefault();
    if (window.__lenis) window.__lenis.scrollTo(href, { offset: -70 });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#050505]/85 backdrop-blur-xl border-b border-neutral-800" : "bg-transparent"
      }`}
    >
      <nav className="max-w-6xl mx-auto flex items-center justify-between px-6 py-4">
        <a href="#" data-testid="nav-logo" onClick={(e) => { e.preventDefault(); window.__lenis?.scrollTo(0); }} className="flex items-center gap-3">
          <LogoMark />
          <span className="font-display font-black uppercase tracking-widest text-sm hidden sm:block">
            Cristian Díaz <span className="text-[#d4af37]">N°42</span>
          </span>
        </a>
        <ul className="flex items-center gap-1 sm:gap-2 overflow-x-auto max-w-[62vw] sm:max-w-none [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace("í", "i")}`}
                onClick={(e) => goTo(e, l.href)}
                className="font-tech text-[10px] sm:text-xs uppercase tracking-[0.2em] text-neutral-400 hover:text-white px-2 sm:px-3 py-2 transition-colors"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}
